import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileQuestion, Home, ArrowLeft, Search } from 'lucide-react';
import { Button } from '../components/ui/Button';

export const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-100 via-primary-50 to-secondary-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-800 py-12 px-4">
      <div className="max-w-md w-full backdrop-blur-lg bg-white/80 dark:bg-slate-800/80 rounded-2xl shadow-xl border border-white/20 dark:border-slate-700/50 p-8">
        {/* Icon */}
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900/30">
          <FileQuestion
            className="h-10 w-10 text-primary-600 dark:text-primary-400"
            aria-hidden="true"
          />
        </div>

        {/* Status code */}
        <h1 className="mb-4 text-6xl font-bold text-gray-900 dark:text-slate-100 text-center">
          404
        </h1>

        {/* Title */}
        <h2 className="mb-3 text-2xl font-semibold text-gray-900 dark:text-slate-100 text-center">
          Page not found
        </h2>

        {/* Description */}
        <p className="mb-8 text-gray-600 dark:text-slate-400 text-center">
          The page you are looking for does not exist or has been moved. Let us help you get back on
          track.
        </p>

        {/* Actions */}
        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            leftIcon={<ArrowLeft className="h-4 w-4" />}
            className="rounded-xl border-primary-200 dark:border-primary-800 bg-white/50 dark:bg-slate-900/50 hover:bg-white/70 dark:hover:bg-slate-800/70"
          >
            Go Back
          </Button>
          <Button
            variant="primary"
            onClick={() => navigate('/')}
            leftIcon={<Home className="h-4 w-4" />}
            className="rounded-xl"
          >
            Go Home
          </Button>
        </div>

        {/* Helpful links */}
        <div className="mt-10 pt-8 border-t border-white/30 dark:border-slate-700/50">
          <h3 className="mb-4 text-sm font-medium text-gray-700 dark:text-slate-300 text-center">
            Looking for something specific?
          </h3>
          <ul className="space-y-2 text-sm text-center">
            <li>
              <button
                onClick={() => navigate('/services')}
                className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium"
              >
                <Search className="h-3 w-3" />
                Browse Services
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate('/dashboard')}
                className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium"
              >
                My Bookings
              </button>
            </li>
            <li>
              <button
                onClick={() => navigate('/contact')}
                className="text-primary-600 hover:text-primary-700 dark:text-primary-400 dark:hover:text-primary-300 hover:underline font-medium"
              >
                Contact Support
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
